import { render } from "./ProductionCadence.vue?vue&type=template&id=1b877885&scoped=true&ts=true&lang=pug"
import script from "./ProductionCadence.vue?vue&type=script&lang=ts"
export * from "./ProductionCadence.vue?vue&type=script&lang=ts"

import "./ProductionCadence.vue?vue&type=style&index=0&id=1b877885&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b877885"]])

export default __exports__